import { gql } from '@apollo/client';

export default gql`
  fragment RefundsFee on Fee {
    name
    code
    price: priceWithCurrency(currency: $currency)
    provisional
    cancelled
    currency
    itemRef
    passengerId
  }
`;
